<template>
  <detail-item
    :without-icon="withoutIcon"
    :icon="iconToDisplay"
    :name-spacing="nameSpacing"
    :large="large"
    with-input
  >
    <template #name>
      <div class="flex justify-between items-center no-wrap full-width">
        <q-input
          v-if="isCustom"
          v-model="metadata.title"
          dense
          outlined
          label="Label"
          input-class="full-width"
          class="q-mb-xs"
        />
        <span v-else>
          {{ metadata.title }}
        </span>
        <color-field
          v-if="!withoutColor"
          v-model="metadata.color"
          dense
          clearable
          class="q-ml-sm"
        />
      </div>
    </template>

    <div class="q-gutter-sm">
      <MetadataItemValue
        v-for="(value, key) in metadata.values"
        :key="key"
        :obj="value"
        :metadata-default="metadataDefault"
        :has-dropdown-options="hasDropdownOptions"
        :show-description="canShowDescription && key === metadata.values.length - 1"
        :show-label="key === 0"
        @remove="onRemoveValue(key)"
      />
      <q-btn
        v-if="maximumOptions < 1 || metadata.values.length < maximumOptions"
        label="Add Another Value"
        flat
        size="12px"
        class="full-width"
        color="blue-8"
        @click="addBlankValue"
      />
    </div>
  </detail-item>
</template>

<script>
import MetadataItemValue from './MetadataItemValue'
import { generateBlankValue, DEFAULT_ICON } from '../metadataMixin'

export default {
  components: {
    MetadataItemValue
  },
  props: {
    metadata: {
      type: Object,
      required: true
    },
    withoutIcon: {
      type: Boolean,
      default: false
    },
    withoutColor: {
      type: Boolean,
      default: false
    },
    nameSpacing: {
      type: Number
    },
    large: {
      type: Boolean
    }
  },
  emits: ['remove'],
  computed: {
    hasDefault () {
      return !!this.metadata.metadata_default
    },
    isCustom () {
      return !this.hasDefault
    },
    metadataDefault () {
      return this.metadata.metadata_default
    },
    iconToDisplay () {
      return this.metadata.icon || DEFAULT_ICON
    },
    maximumOptions () {
      return this.hasDefault ? this.metadataDefault.maximum_options : 0
    },
    canShowDescription () {
      return this.hasDefault && !!this.metadataDefault.description
    },
    hasDropdownOptions () {
      return this.hasDefault && this.metadataDefault.dropdown_options.length > 0
    }
  },
  methods: {
    onRemoveValue (key) {
      this.metadata.values.splice(key, 1)

      // Remove this metadata instance entirely if there are no values left
      if (this.metadata.values.length < 1) {
        this.$emit('remove')
      }
    },
    addBlankValue () {
      this.metadata.values.push(generateBlankValue())
    }
  }
}
</script>
